"use strict";
//  2
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARAMS = exports.COMMERCIAL_LAYOUT = exports.NETWORK_STATUS = exports.ENVIRONMENTS = exports.DEVICES = void 0;
exports.DEVICES = {
    MOBILE: 'mobile',
    PC: 'pc',
    TABLET: 'tablet',
};
exports.ENVIRONMENTS = {
    QA: 'qa',
    DEV: 'dev',
    PROD: 'prod',
};
exports.NETWORK_STATUS = {
    FETCHING: 'fetching',
    SUCCESS: 'success',
    ERROR: 'error',
};
exports.COMMERCIAL_LAYOUT = {
    PROMO_ESTATICO_DERECHA: 'promo_compacto_original_estatico_derecha',
    PROMO_ESTATICO_IZQUIERDA: 'promo_compacto_original_estatico_izquierda',
    ESTATICO_DERECHA: 'compacto_originial_estatico_derecha',
    ESTATICO_IZQUIERDA: 'compacto_original_estatico_izquierda',
    COMPLETO_ESTATICO: 'completo_original_estatico',
    COMPLETO_VIDEO: 'completo_original_video',
};
exports.PARAMS = {
    BUNDLE: 'productOffering',
    INCLUDED_DEVICE: ['poR', 'idColorRA', 'idCapacidadRA'],
};
//# sourceMappingURL=index.js.map